import { useDashboardCard } from '@/features/dashboard/api/queries'
import { MARKET_FILTER, type CardStub } from '@/features/dashboard/api/schemas'
import type { CardFilters } from '@/features/dashboard/api/client'
import { useDashboardFilters } from './useDashboardFilters'
import { REGULATORY_FILTERS, useRegulatoryFilters } from './regulatoryFilters'

/**
 * A card drawn in a deep dive. It is fetched for that deep dive, so its
 * settings there apply, and sliced by the filters its stub lists: the markets,
 * and the regulatory selections. It takes no timeframe or range: deep dives
 * show the whole (monthly) series.
 */
export const useDeepDiveCard = (stub: CardStub, deepDiveId: string) => {
  const { markets, clearMarkets } = useDashboardFilters()
  const { selection } = useRegulatoryFilters()

  const filters: CardFilters = { deepDive: deepDiveId }
  if (stub.filters?.includes(MARKET_FILTER)) filters.markets = markets
  for (const { filter, param } of REGULATORY_FILTERS) {
    if (stub.filters?.includes(filter) && selection[param].length > 0) {
      filters[param] = selection[param]
    }
  }

  return { ...useDashboardCard(stub.cardId, filters), clearMarkets }
}
